<template>
  <div class="card-actions action-deal-in-progress">
    <panel
      icon="ph_warning-fill_yellow"
      :title="trans('deal_dashboard.action.in_progress.panel.title')"
      type="warning"
      :content="trans('deal_dashboard.action.in_progress.panel.content')"
    />
    <div class="modal-state_content msc">
      <span
        class="msc_title"
      >
        {{ trans('deal_dashboard.action.in_progress.visit.title') }}
      </span>
      <cancel-visit-summary
        :interlocutor="interlocutor"
        :deal="deal"
        is-seller
      />
    </div>
    <div class="card-actions__cta card-actions__cta--bottom action-ask-cancel-visit">
      <button
        class="btn btn--cancel"
        @click="onCancelClick"
      >
        {{ trans('messaging.actions.visit.cancel.back') }}
      </button>
      <a
        class="btn btn--visit-cancel"
        type="button"
        :href="cancelVisitUrl"
      >
        <span>{{ trans('messaging.actions.visit.cancel.cta') }}</span>
      </a>
    </div>
  </div>
</template>
<script>
import Panel from '@components-molecules/Panel.vue';
import { DealStep } from '@enums/dealSteps';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';
import {
  URL_DEAL_CHANGE_STATE,
  URL_DEAL_MESSAGING,
} from '@tools/routes/routes';
import Logger from '@tools/logger/logger';
import momentMixin from '@tools/moment';
import requests from '@tools/requests-mixin';
import ActionsMixins from './actions-mixins';
import { EVENTS } from './constants';
import CancelVisitSummary from '../../deal/CancelVisitSummary.vue';

export default {
  components: { CancelVisitSummary, Panel },
  mixins: [ ActionsMixins, momentMixin, requests ],
  props: {
    deal: { type: Object, required: true },
    interlocutor: { type: Object, required: true },
  },
  data() {
    return {
      displayModal: false,
      title: this.trans('deal_dashboard.action.in_progress.title'),
    };
  },
  computed: {
    cancelVisitUrl() {
      return URL_DEAL_MESSAGING.replace('{id}', this.deal.id).concat('?cancel-visit=1');
    },
  },
  mounted() {
    if (this.deal.visited_date === null || this.isBeforeToday(this.deal.visited_date.iso)) {
      this.performAction();
    } else {
      this.displayModal = true;
      this.$emit(EVENTS.TITLE_UPDATE, this.title);
    }
  },
  methods: {
    onCancelClick() {
      this.$emit(EVENTS.ACTION_CANCELLED);
    },
    async performAction() {
      let response = null;
      try {
        response = await this.post(
          URL_DEAL_CHANGE_STATE
            .replace('{id}', this.deal.id)
            .replace('{state}', DealStep.IN_PROGRESS),
          {},
        );
      } catch (error) {
        Logger.error(error);
      }
      if (response && response.status === 200) {
        flashBagSuccess(this.trans('deal_dashboard.action.success'));
        this.$emit(EVENTS.ACTION_PERFORMED);

        return;
      }
      flashBagError(this.trans('deal_dashboard.action.failure'));
      this.$emit(EVENTS.ACTION_PERFORMED);
    },
  },
};
</script>
